/**
 * DIKKERS WINE OVERLAY
 * Productpagina: klik op trigger toont wijn overlay met animaties
 */
(function () {
  'use strict';

  function openOverlay(wrapper) {
    var overlay = wrapper.querySelector('.dikkers-wine-overlay');
    if (!overlay) return;

    // Activeer overlay
    overlay.classList.add('is-active');
    wrapper.classList.add('dikkers-overlay-active');

    // Animeer smaakbalken: reset naar 0 dan naar echte waarde
    var fills = overlay.querySelectorAll('.dikkers-wine-overlay__bar-fill');
    fills.forEach(function (fill) {
      var targetWidth = fill.getAttribute('data-width') || fill.style.width;
      if (!fill.getAttribute('data-width')) {
        fill.setAttribute('data-width', fill.style.width);
      }
      fill.style.width = '0%';
      // Kleine vertraging zodat CSS transition het oppakt
      setTimeout(function () {
        fill.style.width = targetWidth;
      }, 50);
    });
  }

  function closeOverlay(wrapper) {
    var overlay = wrapper.querySelector('.dikkers-wine-overlay');
    if (!overlay) return;

    overlay.classList.remove('is-active');
    wrapper.classList.remove('dikkers-overlay-active');

    // Reset smaakbalken
    var fills = overlay.querySelectorAll('.dikkers-wine-overlay__bar-fill');
    fills.forEach(function (fill) {
      fill.style.width = '0%';
    });
  }

  function init() {
    // Trigger knop opent overlay
    document.querySelectorAll('.dikkers-wine-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var wrapper = trigger.closest('.product__media-image-wrapper');
        if (!wrapper) return;
        openOverlay(wrapper);
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var wrapper = trigger.closest('.product__media-image-wrapper');
          if (!wrapper) return;
          openOverlay(wrapper);
        }
      });
    });

    // Klik op overlay sluit hem
    document.querySelectorAll('.dikkers-wine-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function () {
        var wrapper = overlay.closest('.product__media-image-wrapper');
        if (!wrapper) return;
        closeOverlay(wrapper);
      });
    });

    // Escape sluit alle overlays
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.product__media-image-wrapper.dikkers-overlay-active').forEach(function (wrapper) {
          closeOverlay(wrapper);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();